import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { handleMobileSearchForm, handleMenu } from '../../actions/index';

import Isvg from 'react-inlinesvg';


import {
    Container,
    Row,
    Col,
    Navbar,
    NavbarBrand,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    Nav, NavItem,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption

} from 'reactstrap';
import { changeLanguage } from '../../actions';
import Categories from '../../components/categories';

import facebook_icon from '../../assets/svg/facebook-icon.svg'
import instagram_icon from '../../assets/svg/instagram-icon.svg'
import credit_card_icon from '../../assets/svg/credit-card-icon.svg'
import heart_icon from '../../assets/svg/heart-icon.svg'
import account_icon from '../../assets/svg/account-icon.svg'
import cart_icon from '../../assets/svg/cart-icon.svg'
import phone_icon from '../../assets/svg/header-phone.svg'
import mail_icon from '../../assets/svg/header-mail.svg'

import hamburger_icon from '../../assets/svg/hamburger-icon.svg'
import home_icon from '../../assets/svg/home-icon.svg'
import phone1_icon from '../../assets/svg/phone.svg'
import category_icon from '../../assets/svg/category-icon.svg'
import searchIcon from '../../assets/svg/search.svg'
import rightArrow from '../../assets/svg/right-arrow.svg'
import searchIcon1 from '../../assets/svg/search-icon.svg'

import logo from '../../assets/svg/logo.svg';
import image from '../../assets/images/no-image.jpg';

import accountIcon from '../../assets/svg/user.svg';

import drawerAccount from '../../assets/svg/drawer/account.svg';
import drawerCart from '../../assets/svg/drawer/cart.svg';
import drawerHome from '../../assets/svg/drawer/home.svg';
import drawerLogout from '../../assets/svg/drawer/logout.svg';
import drawerPhone from '../../assets/svg/drawer/phone.svg';
import drawerWishlist from '../../assets/svg/drawer/wishlist.svg';
import drawerQuestion from '../../assets/svg/question.svg';
import close_icon from '../../assets/svg/close-ico.svg';

class HomeHeader extends Component {
    constructor(props) {
        super(props);
        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.suggestions = this.suggestions.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.state = {
            suggestions: [],
            search: '',
            imageErrors: {},
            width: 0, height: 0,
            showSearch: false,
            yScroll: 0

        };

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);


    }


    listenToScroll = () => {
        const yScroll =
            document.body.scrollTop || document.documentElement.scrollTop


        this.setState({
            yScroll: yScroll,
            scrollHeader: yScroll < this.state.yScroll,
        })
    }




    componentDidMount() {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
        document.addEventListener('mousedown', this.handleClickOutside);
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.listenToScroll)

    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }


    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });

        this.props.socketIOClient.on('suggestions', (data) => {
            console.log(data);

            this.setState({
                imageErrors: {},
                suggestions: data.products
            })
        });



    }
    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.listenToScroll)

        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("suggestions");
        //this.props.socketIOClient.removeAllListeners("fetchProductVariations");

    }


    suggestions() {
        if (this.state.search.length) {
            this.props.socketIOClient.emit("suggestions", { search: this.state.search });
        }
    }
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({
                suggestions: []
            })
        }

        if (this.leftMenuRef && !this.leftMenuRef.contains(event.target)) {
            this.setState({
                leftMenu: null
            })
        }

        if (this.rightMenuRef && !this.rightMenuRef.contains(event.target)) {
            this.setState({
                rightMenu: null
            })
        }
    }

    _renderTree = (items) => {
        let breadcrumb = this.props[0].location.pathname.split('/category').pop();

        return items.map((item, idx) => {
            return (
                <li key={idx}>
                    <Link to={`/category${item.Breadcrumb}`}  className={breadcrumb == item.Breadcrumb ? 'active' : null} onClick={() => this.setState({ mobileNavigation: null })}><div className="head"><span>{item.Name}</span></div></Link>

                    {
                        item.subcategories && item.subcategories.length && breadcrumb.indexOf(item.Breadcrumb) !== -1 ?
                            <ul>
                                {this._renderTree(item.subcategories)}
                            </ul>
                            :

                            null
                    }


                </li>
            )
        }
        )
    }



    render() {
        return (
            <header className={this.state.mobileNavigation ? '' : this.state.yScroll > 100 && this.state.scrollHeader ? `scroll-header` : this.state.yScroll < 50 ? '' : 'hide-header'}>
                <div className="header-top">
                    <Container>
                        <Row>
                            <Col lg="12" className="header-top-container">
                                <div className="contact">
                                    <div>
                                        <Isvg src={phone_icon} />
                                        +387 63 523 523

                                        </div>

                                    <div>
                                        <Isvg src={mail_icon} />
                                        <a href="mailto:info@marvo.ba">info@marvo.ba</a>
                                    </div>

                                </div>
                                <div className="buttons">
                                    {this.props.uData ?
                                        <Link to='/account'><button className="register">Nalog</button></Link>

                                        :
                                        <>
                                            <Link to='/login'><button className="login">Uloguj se</button></Link>
                                            <Link to='/register'><button className="register">Registruj se</button></Link>
                                        </>
                                    }
                                    <Link to='/cart'><button className="cart"><Isvg src={cart_icon} /> Korpa {this.props.cartCount ?<div className="cart-count">{this.props.cartCount}</div>:null} </button></Link>
                                </div>

                            </Col>


                        </Row>
                    </Container>
                </div>
                <div className="mobile-header">
                    <Container>
                        <Row>
                            <Col xs="2" className={this.state.mobileNavigation ? 'hamburger hamburger-animation' : 'hamburger'}>
                                <button onClick={() => this.setState({ mobileNavigation: !this.state.mobileNavigation })}>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </button>
                            </Col>
                            <Col lg="3" xs="8" className={"logo"}>
                                <Isvg src={logo} />
                                <input type="text" value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} onKeyUp={(e) => {
                                    if (e.keyCode == 13) {
                                        e.preventDefault();
                                        this.props[0].history.push(`/category${this.state.search ? `?search=${encodeURIComponent(this.state.search)}` : ''}`)
                                    }
                                }}

                                />

                                <button className="search" onClick={() => {
                                    this.props[0].history.push(`/category${this.state.search ? `?search=${encodeURIComponent(this.state.search)}` : ''}`)

                                }}>
                                    <Isvg src={searchIcon} />
                                </button>

                            </Col>
                            <Col xs="2" className="mobile-actions">
                                <Link to='/cart'>
                                    <button className="cart">
                                        <Isvg src={cart_icon} />
                                        {this.props.cartCount ?<div className="cart-count">{this.props.cartCount}</div>:null}
                                    </button>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <Container>
                    <Row>
                        <Col lg="12" className="navigation-wrap">
                            <Link to='/' className="logo">
                                <Isvg src={logo} />
                            </Link>
                            <ul className="navigation">
                                <li className={this.props[0].location.pathname == '/' ? "active" : null}><Link to='/'>Početna</Link></li>
                                {window.innerWidth < 768 ?
                                    <li className={this.props[0].location.pathname == '/category' && this.props[0].location.search.indexOf('display') == -1 ? "active" : null}><Link to='/category'>Proizvodi</Link></li>

                                    :
                                    <UncontrolledDropdown>
                                        <DropdownToggle caret>
                                            Poizvodi
                                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {
                                                this.props.categories && this.props.categories.map((item, idx) => {
                                                    return (
                                                        <Link to={`/category${item.Breadcrumb}`}>   <DropdownItem>{item.Name} </DropdownItem></Link>
                                                    )
                                                })
                                            }
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                }

                                <li className={this.props[0].location.search && this.props[0].location.search.indexOf('display=offer') !== -1 ? "active" : null}><Link to='/category?display=offer'>Na akciji</Link></li>
                                <li className={this.props[0].location.search && this.props[0].location.search.indexOf('display=promoted') !== -1 ? "active" : null}><Link to='/category?display=promoted'>Izdvajamo</Link></li>
                                <li className={this.props[0].location.pathname == '/page/o-nama' ? "active" : null}><Link to='/page/o-nama'>O nama</Link></li>
                                <li className={this.props[0].location.pathname.indexOf('/novosti') !== -1 ? "active" : null}><Link to='/novosti'>Novosti</Link></li>
                                <li className={this.props[0].location.pathname == '/contact' ? "active" : null}><Link to='/contact'>Kontakt</Link></li>
                            </ul>
                            <div className="search">
                                    <input onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            this.props[0].history.push(`/category/?search=${this.state.search}`)
                                        }
                                    }} onFocus={this.suggestions} value={this.state.search} onChange={(e) => { this.setState({ search: e.target.value }, () => this.suggestions()) }} type="text" placeholder={"Unesite pojam za pretragu..."} />
                                    <button onClick={() => {
                                        this.props[0].history.push(`/category/?search=${this.state.search}`)
                                    }}> <Isvg src={searchIcon1} /></button>
                                    {this.state.suggestions.length ?
                                        <div className="search-results" ref={(node) => { this.wrapperRef = node; }}>
                                            <h6>Artikli</h6>
                                            <ul>
                                                {
                                                    this.state.suggestions.map((item, idx) => {
                                                        return (
                                                            <li key={idx}><Link to={`/product/${item.Alias}/${item._id}`}><img onError={() => {
                                                                let imageErrors = this.state.imageErrors;
                                                                imageErrors[item.Image] = true;
                                                                this.setState({ imageErrors })
                                                            }} src={!this.state.imageErrors[item.Images && item.Images.length && item.Images[0]] ? (item.Images && item.Images.length && item.Images[0]) ? item.Images[0] : image : image} />{item.Name}</Link></li>

                                                        )
                                                    })
                                                }

                                            </ul>
                                        </div>
                                        : null}
                                </div>

                        </Col>
                    </Row>

                </Container>

                <div className={this.state.mobileNavigation ? "mobile-menu-wrap mobile-menu-open" : "mobile-menu-wrap"}>
                    <div className="overlay" onClick={() => this.setState({ mobileNavigation: null })}></div>
                    <div className="mobile-menu">
                        <div className="user-info">
                            <Isvg src={accountIcon} />
                            <h6>{this.props.uData && this.props.uData.name ? this.props.uData.name : 'Nalog'}</h6>
                            <p>{this.props.uData ? this.props.uData.email : 'Sign up or Login to make purchase.'} </p>
                            <div className={this.props.uData ? "buttons" : "buttons buttons-login"}>
                                {this.props.uData ?
                                    <>
                                        <Link to={'/account'}><button>Nalog</button></Link>
                                        <Link to={'/account/orders'}> <button>Narudžbe</button></Link>
                                        <button onClick={() => { this.props.setUserData(null); this.props.socketIOClient.emit('userLogout', {}); }}>Odjavi se</button>

                                    </>
                                    :
                                    <>
                                        <Link to={'/login'}><button>Prijava</button></Link>
                                        <Link to={'/register'}><button>Registracija</button></Link>

                                    </>
                                }
                            </div>
                        </div>

                        <Link to='/category'><h5>Kategorije</h5></Link>


                        {this.props.categories.length ?
                            <ul className="categories-tree">
                                {this._renderTree(this.props.categories)}
                            </ul>

                            :
                            null
                        }

                    </div>
                </div>
            </header>

        );
    }
}

const mapStateToProps = state => ({
    searchForm: state.searchForm,
    menu: state.menu
});

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleChange: (val) => {
            dispatch(handleMobileSearchForm(val))
        },
        handleMenu: (val) => {
            dispatch(handleMenu(val))
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(HomeHeader);
